/**
 * DialogContentComponent.js
 * 
 * Created on Oct 8, 2013, 4:06:11 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/

import Content from "./Content";
import ContentFactory from "./ContentFactory";
import ContentTypes from "./ContentTypes";

export default class DialogContentComponent extends Content {
    constructor(languagePack, contentID, npcID, dialogID, playerInitiated, label) {
        super(DialogContentComponent.NAME, DialogContentComponent.TYPE, label, languagePack, contentID);
        this._npcID = npcID;
        this._dialogID = dialogID;
        this._playerInitiated = playerInitiated;
    }
    remove() {
        this._npcID = null;
        this._dialogID = null;
        super.remove();
    }
    getNpcID() {
        return this._npcID;
    }
    setNpcID(value) {
        this._npcID = value;
    }
    getDialogID() {
        return this._dialogID;
    }
    setDialogID(value) {
        this._dialogID = value;
    }
    getPlayerInitiated() {
        return this._playerInitiated;
    }
    setPlayerInitiated(value) {
        this._playerInitiated = value;
    }
    clone() {
        var clone = ContentFactory.getContent(ContentTypes.TYPE_DIALOG, this.getLanguagePack());
        clone.setContentID(this.getContentID());
        clone.setNpcID(this.getNpcID());
        clone.setDialogID(this.getDialogID());
        clone.setPlayerInitiated(this.getPlayerInitiated());
        return clone;
    }
    convertToObject() {
        return this.getObject(["npcID", "dialogID", "playerInitiated"]);
    }
    getDescriptionLabel() {
        var label;

        label = this.dialogID.toString();
        if (isNull(label) || label === "") {
            label = "Dialog: <NO DIALOG>";
        }

        else {
            label = "Dialog: " + label;
        }
        return label;
    }
}

DialogContentComponent.NAME = "Dialog";
DialogContentComponent.TYPE = "engDialogContentComponent";











